let cached: boolean | null = null;

/**
 * Check if WebGL is supported by the browser.
 * Result is cached after the first call to avoid creating
 * throwaway WebGL contexts that count toward the browser limit.
 */
export const isWebGLSupported = (): boolean => {
  if (typeof window === "undefined") {
    return true;
  }

  if (cached !== null) {
    return cached;
  }

  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    const supported = gl !== null;
    if (gl && "getExtension" in gl) {
      (gl as WebGLRenderingContext)
        .getExtension("WEBGL_lose_context")
        ?.loseContext();
    }
    cached = supported;
    return supported;
  } catch {
    cached = false;
    return false;
  }
};
